import { normalizeLocale } from '@/utils/i18n';

import { GetUserApiResponse } from '../api/models/user.models';

export const parseUser = (user: GetUserApiResponse) => ({
  ...user,
  language: normalizeLocale(user.language),
});
